import React, { useEffect, useState } from 'react';
import axios from 'axios';
import PropTypes from 'prop-types';
import CircularProgress from '@material-ui/core/CircularProgress';
import BuilderJobs from './BuilderJobs';
import { API_URL_JOBS, API_KEY_JOBS } from '../../constants';

const styles = {
  loadingWrapper: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    minHeight: 200,
  },
};

const BuilderJobsContainer = props => {
  const [jobsResponse, setJobsResponse] = useState([]);
  const [hasUpdated, setHasUpdated] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const { builder, dispatchApiCallFailed, dispatchApiCallSuccess } = props;

  const getJobs = async () => {
    // console.log('get jobs', builder.username);
    const token = localStorage.getItem('accessToken');
    const response = await axios.get(
      `${API_URL_JOBS}/admin/users/${builder.username}/jobs`,
      {
        headers: {
          'Content-Type': 'application/json',
          'x-api-key': `${API_KEY_JOBS}`,
          Authorization: `Bearer ${token}`,
        },
        validateStatus(status) {
          return status === 200;
        },
      },
    );
    return response.data;
  };

  const handleLeadJobUpdate = async job => {
    try {
      const {
        notes,
        budget,
        typeOfJob,
        plannedStartDate,
        locationOfProject,
        customerDetail,
        statusCode,
      } = job;
      const { firstName, lastName, email, phoneNumber } = customerDetail;
      const token = localStorage.getItem('accessToken');
      const username = localStorage.getItem('username');

      // axios.put(url[, data[, config]])

      await axios({
        method: 'POST',
        headers: {
          Authorization: `Bearer ${token}`,
          'Content-Type': 'application/json',
          'x-api-key': API_KEY_JOBS,
        },
        data: {
          builderId: builder.username,
          username,
          activityName: 'Job Updated',
        },
        url: `${API_URL_JOBS}/activityLog/admin`,
        validateStatus(status) {
          return status >= 200 && status <= 403; // default
        },
      });
      const response = await axios.put(
        `${API_URL_JOBS}/admin/users/${builder.username}/jobs/${job.id}`,
        {
          notes,
          budget,
          typeOfJob,
          plannedStartDate,
          locationOfProject,
          customerDetail: { firstName, lastName, email, phoneNumber },
          statusCode,
        },
        {
          headers: {
            'Content-Type': 'application/json',
            'x-api-key': `${API_KEY_JOBS}`,
            Authorization: `Bearer ${token}`,
          },
        },
      );
      setHasUpdated(true);
      return response.data;
    } catch (error) {
      return error;
    }
  };

  useEffect(() => {
    setIsLoading(true);
    getJobs()
      .then(response => {
        setJobsResponse(response.jobs);
        if (hasUpdated) {
          setHasUpdated(false);
        }
        setIsLoading(false);
        dispatchApiCallSuccess();
      })
      .catch(() => {
        setIsLoading(false);
        dispatchApiCallFailed();
      });
  }, [hasUpdated]);

  return (
    <div>
      {isLoading ? (
        <div style={styles.loadingWrapper}>
          <CircularProgress size={40} />
        </div>
      ) : (
        <div>
          <BuilderJobs
            jobs={jobsResponse}
            builder={builder}
            handleLeadJobUpdate={handleLeadJobUpdate}
            dispatchApiCallFailed={dispatchApiCallFailed}
            dispatchApiCallSuccess={dispatchApiCallSuccess}
          />
        </div>
      )}
    </div>
  );
};

const propTypes = {
  builder: {
    username: PropTypes.string,
  },
  dispatchApiCallFailed: PropTypes.func,
  dispatchApiCallSuccess: PropTypes.func,
};

BuilderJobsContainer.propTypes = propTypes;

export default BuilderJobsContainer;
